import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import useHttp from "../../hook/use-http";
import { toast } from "react-toastify";
import { formatDateTime, formatDateHour } from "../Utility/FormatTime";
import "./datatables.scss";
import { BsEye } from "react-icons/bs";

export default function CatalogoElectronicoReporte({ history }) {
  const [data, setData] = useState([]);
  const [dataList, setDataList] = useState(0);
  const { SearchBar } = Search;
  const { loading, error, request } = useHttp();

  // Estado para el modal
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedObservations, setSelectedObservations] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + localStorage.getItem("token"));

      request({ url: `/auth/util/list`, method: "GET", headers: myHeaders }, handleGetDataResponse);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetDataResponse = (data) => {
    if (data?.error) {
      toast("Ha ocurrido un error, la data no ha sido cargada.", { type: "error", autoClose: 10000 });
      return;
    }

    if (data.status === 401) {
      if (data.errorCode === 12) {
        localStorage.removeItem("token");
        history.push("/login");
      }
      toast(data.message, { type: "error", autoClose: 10000 });
    } else {
      const dataClean = data.map((item, index) => ({
        ...item,
        index: index + 1,
        name: item.name || "No info",
        email: item.email || "No info",
        comments: item.comments.length > 0 ? item.comments : ["No info"],
        country: item.country || "No info",
        region: item.region || "No info",
        date: formatDateTime(item.createdDate),
        hour: formatDateHour(item.createdDate),
      }));

      setDataList(dataClean.length);
      setData(dataClean);
    }
  };

  // Función para abrir el modal con las observaciones
  const handleOpenModal = (observations) => {
    setSelectedObservations(observations);
    setModalOpen(true);
  };

  const columns = [
    { dataField: "index", text: "ID", sort: true },
    { dataField: "date", text: "FECHA", sort: true },
    { dataField: "hour", text: "HORA", sort: true },
    { dataField: "name", text: "NOMBRE", sort: true },
    { dataField: "email", text: "EMAIL", sort: true },
    { dataField: "country", text: "PAÍS", sort: true },
    { dataField: "region", text: "REGIÓN", sort: true },
    {
      dataField: "comments",
      text: "OBSERVACIONES",
      formatter: (cell) => (
        <Button className="lexmark-color text-center" size="sm" onClick={() => handleOpenModal(cell)}>
          <BsEye size={16} /> {/* Ícono de ojo */}
        </Button>
      ),
    },
  ];

  const pageOptions = { sizePerPage: 10, totalSize: dataList, custom: true };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider pagination={paginationFactory(pageOptions)} keyField="id" columns={columns} data={data}>
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider keyField="id" columns={columns} data={data} search>
                        {(toolkitProps) => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col md="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="search-box chat-search-box" />
                                  </div>
                                </div>
                              </Col>
                            </Row>

                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    id="table-responsive"
                                    keyField={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <Row className="align-items-md-center mt-30">
                              <Col className="inner-custom-pagination d-flex">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone {...paginationProps} />
                                </div>
                                <div className="text-md-right ms-auto">
                                  <PaginationListStandalone {...paginationProps} />
                                </div>
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Modal para mostrar observaciones */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)}>
        <ModalHeader toggle={() => setModalOpen(false)}>Observaciones</ModalHeader>
        <ModalBody>
          {selectedObservations.length > 0 ? (
            <ul>
              {selectedObservations.map((obs, index) => (
                <li key={index}>{obs}</li>
              ))}
            </ul>
          ) : (
            <p>No hay observaciones.</p>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}
